import Vue from 'vue'
import Quasar, { Ripple, CloseOverlay, Notify, Dialog, Screen, QChip} from 'quasar-framework'

Vue.use(Quasar, { directives: [Ripple, CloseOverlay], plugins: [Notify, Dialog, Screen, QChip]})


// WEBPACK FOOTER //
// ./resources/assets/js/plugins/quasar.js